import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-exg-filter',
  templateUrl: './exg-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class ExgFilterComponent extends ExcTranslation {
  @Output('onActivateFilter') onActivateFilterEmitter: EventEmitter<any> = new EventEmitter();

  @Input() MetaInfo: any;
  @Input() uiFilter: any;
  @Input() uiSort: any;

  @Input() visibility = true;
  @Input() containerClass = 'app-filter-default';

  @Input() showFilter = false;
  @Input() showSort = false;
  @Input() showSearch = false;

  trans: {[key: string]: string} = {};

  constructor() {
    super();
  }

  getLokalTranslation(name: string, param?: any): string {
    if (!this.trans[name] && !this.visibility) {
      this.trans[name] = this.getTranslation(name, param);
    }
    return this.trans[name];
  }

  ComputeDataFilter(targetobj: any, source: any[], distinct: any[]): void {
    targetobj.dataFilter = {};
    distinct.forEach((obj) => {
      targetobj.dataFilter[obj.filterField] = [];
      ExcCoreModule.Array.GetAll(source, 'filterField', obj.filterField).forEach((objdetail: any) => {
        targetobj.dataFilter[objdetail.filterField].push(objdetail.filterCondition);
      });
    });
  }

  ResetFilter(): void {
    const _self = this;
    _self.uiFilter.forEach((obj: any) => {
      obj.uiValue = false;
      if (obj.filterType === 2) {
        obj.filterCondition.value = '';
      }
    });
    _self.uiSort.forEach((obj: any) => {
      obj.uiValue = obj.sortDefault;
    });
    _self.ApplyFilter(true);
  }

  ApplyFilter(forceRecompute = false): void {
    const _self = this;
    if (_self.showFilter || _self.showSearch || forceRecompute) {
      const activeFilter: any[] = ExcCoreModule.Array.GetAll(_self.uiFilter, 'uiValue', true);
      const distinctActiveFilter: any[] = ExcCoreModule.Array.DistinctObject(activeFilter, 'filterField');
      _self.ComputeDataFilter(_self.MetaInfo, activeFilter, distinctActiveFilter);
    }
    if (_self.showSort || forceRecompute) {
      _self.ComputeSortValue(_self.MetaInfo, _self.uiSort);
    }
    _self.onActivateFilterEmitter.emit(_self.MetaInfo);
  }

  ChangeSearchValue(obj: any): void {
    obj.uiValue = (obj.filterCondition.value.length > 0);
  }

  ChangeSortValue(obj: any): void {
    obj.uiValue = (obj.uiValue + 1) % 3;
  }

  ComputeSortValue(targetobj: any, source: any[]): void {
    const sval = ['', 'asc', 'desc'];
    targetobj.dataSort = {};
    source.forEach((obj) => {
      if (obj.uiValue > 0) {
        targetobj.dataSort[obj.sortField] = sval[obj.uiValue];
      }
    });
  }
}
